import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home2Icon, MealIcon, Plan2Icon, ProfileIcon } from "../../assets/icons";
import styles from "./style.module.scss";
import { getTenant } from "../../theme";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useTranslation } from "react-i18next";
import { checkEmptyObj } from "../../utils";

export default function MobileFooter() {
  const { t, i18n } = useTranslation("mobileFooter");
  const user = useSelector((state: RootState) => state.user);
  const { pathname } = useLocation();
  const tenant = getTenant();

  const isRTL = i18n.language === "ar";

  const hide = useMemo(() => {
    let routes: string[] = [];
    const isInSalesFlow = sessionStorage.getItem("joinNowRouted") === "true" && tenant.name === "rejeem";

    if (tenant.name === "rejeem" && !checkEmptyObj(user)) {
      routes = [
        "/join",
        "/find-best-plan",
        "/congrats",
        "/diet-preference",
        "/recommended-plans",
        "/all-plans",
        "/featured-plans",
      ];
    } else {
      routes = ["/", "/join", "/find-best-plan", "/congrats", "/featured-plans"];
    }

    // Hide footer on day-selection and summary pages during sales flow
    const hideDuringSalesFlow =
      isInSalesFlow &&
      (pathname.includes("/day-selection") || pathname.includes("/summary") || pathname.includes("/meal-selection"));

    // Rejeem's refactored package-selection screen has its own bottom bar.
    const hideForRejeemPackageSelection = tenant.name === "rejeem" && pathname.includes("/meal-selection");

    return routes.includes(pathname) || hideDuringSalesFlow || hideForRejeemPackageSelection;
  }, [pathname, user]);

  if (hide) {
    return <></>;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: 2,
        height: 70,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "text.bodyBg",
        borderTop: "1px solid",
        borderColor: "text.base50",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        boxShadow: "0px -2px 10px 0px rgba(0, 0, 0, 0.08)",
      }}
    >
      {tenant.name === "rejeem" ? (
        <Link className={`${pathname === "/" ? styles.active : ""} ${styles.link}`} to={`/`}>
          <Home2Icon width={32} height={32} />
          <Typography className={styles.text}>{t("home")}</Typography>
        </Link>
      ) : null}

      {tenant.name === "rejeem" ? (
        <Link
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className={`${
            pathname.includes(checkEmptyObj(user) ? "/all-plans" : "/recommended-plans") ? styles.active : ""
          } ${styles.link}`}
          to={checkEmptyObj(user) ? `/all-plans` : `/recommended-plans`}
        >
          <Plan2Icon width={32} height={32} />
          <Typography className={styles.text}>{t("plans")}</Typography>
        </Link>
      ) : (
        <Link
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className={`${pathname.includes("/plans") ? styles.active : ""} ${styles.link}`}
          to={`/plans`}
        >
          <Plan2Icon width={32} height={32} />
          <Typography className={styles.text}>{t("plans")}</Typography>
        </Link>
      )}

      <Link
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={`${pathname.includes("/meal-plan") ? styles.active : ""} ${styles.link}`}
        to={`/meal-plan`}
      >
        <MealIcon />
        <Typography className={styles.text}>{t("myPlan")}</Typography>
      </Link>
      <Link
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={`${pathname.includes("/profile") ? styles.active : ""} ${styles.link}`}
        to={`/profile`}
      >
        <ProfileIcon />
        <Typography className={styles.text}>{t("profile")}</Typography>
      </Link>
    </Box>
  );
}
